import ThisModule from "./StepChooseSessionType";

export default ThisModule;
